export const users = [
  { id: 1, name: 'John Doe', email: 'john@company.com', department: 'Sales', role: 'Manager' },
  { id: 2, name: 'Jane Smith', email: 'jane@company.com', department: 'Marketing', role: 'Specialist' },
  { id: 3, name: 'Mike Johnson', email: 'mike@company.com', department: 'IT', role: 'Developer' },
  { id: 4, name: 'Sarah Williams', email: 'sarah@company.com', department: 'HR', role: 'Manager' },
  { id: 5, name: 'David Brown', email: 'david@company.com', department: 'Finance', role: 'Analyst' },
];

export const tickets = [
  {
    id: 1,
    title: 'Need marketing specialist for client project',
    description: 'We need a marketing specialist to help with the upcoming client campaign',
    assignee: 2,
    status: 'Pending Approval',
    priority: 'High',
    leadTime: '2 weeks',
    expectedDateStart: '2023-06-01',
    expectedDateEnd: '2023-06-15',
    actualDateStart: null,
    actualDateEnd: null,
    resolvedDate: null,
    isActive: true,
    createdAt: '2023-05-20',
    updatedAt: '2023-05-20'
  },
  {
    id: 2,
    title: 'IT support for new sales software',
    description: 'Need IT support to implement new CRM features',
    assignee: 3,
    status: 'In Progress',
    priority: 'Medium',
    leadTime: '3 weeks',
    expectedDateStart: '2023-05-15',
    expectedDateEnd: '2023-06-05',
    actualDateStart: '2023-05-16',
    actualDateEnd: null,
    resolvedDate: null,
    isActive: true,
    createdAt: '2023-05-10',
    updatedAt: '2023-05-16'
  },
  {
    id: 3,
    title: 'HR support for new hires',
    description: 'Need HR to process paperwork for 5 new sales hires',
    assignee: 4,
    status: 'Completed',
    priority: 'Low',
    leadTime: '1 week',
    expectedDateStart: '2023-04-01',
    expectedDateEnd: '2023-04-08',
    actualDateStart: '2023-04-02',
    actualDateEnd: '2023-04-07',
    resolvedDate: '2023-04-07',
    isActive: true,
    createdAt: '2023-03-28',
    updatedAt: '2023-04-07'
  }
];